import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-maintenance',
  templateUrl: './app-maintenance.component.html',
  styleUrls: ['./app-maintenance.component.scss']
})
export class AppMaintenanceComponent {
  resumeTime: string = '';

  constructor(private router: Router) {
    const nav = this.router.getCurrentNavigation();
    const maintenanceEnd = nav?.extras?.state?.['maintenanceEnd']
      ?? history?.state?.maintenanceEnd;

    if (maintenanceEnd) {
      const date = new Date(maintenanceEnd);
      this.resumeTime = date.toLocaleString([], {
        hour12: true,   // AM/PM format
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }
}